// extracted by mini-css-extract-plugin
export default {"tabs":"asvLLE"};